module.exports = __webpack_public_path__ + "static/image/history/m/201812@3x.ver2_0_2.jpg?bb5cc359";